<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="'Customer Summary'"
  (nzOnCancel)="onCancelClick()"
  [nzOkText]="null"
  [nzCancelText]="'Close'"
>
  <ng-container *nzModalContent>
    <div class="vertical-large">
      <button
        class="fit-content right"
        nz-button
        nzType="default"
        nzSize="default"
        [nzDanger]="false"
        (click)="onRegenerateClick()"
      >
        <span nz-icon style="font-size: 18px" class="material-symbols-rounded">refresh</span>
        Regenerate
      </button>

      @if (isLoading()) {
        <nz-skeleton [nzActive]="true"></nz-skeleton>
      } @else {
        <div [innerHTML]="summary() | markdownIt"></div>
      }
    </div>
  </ng-container>
</nz-modal>
